<template>
  <div class="keywords">
    <InputWithContextMenu
      v-model="search"
      class="keywords__input"
      placeholder="Search"
      type="text"
    />
    <a class="keywords__btn" href="javascript:void(0);">
      <span class="iconfont isearch"></span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'

import type { ForumView } from '@/models/forum'

const props = defineProps<{
  forum: ForumView
}>()

const search = ref('')

watch(search, (newSearch) => {
  props.forum.filter(newSearch)
})
</script>
